import { css } from '@emotion/react';

export const cardStyles = css`
  height: unset;
  margin: 0 0 250px;
`;
